import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type LikeCommentInput = {
  predictionMarketId: string;
  commentId: string;
};

const fetcher = async (
  _url: string,
  { arg: { predictionMarketId, commentId } }: { arg: LikeCommentInput },
): Promise<void> => {
  const headers = authHeader.getOrThrow();
  await romanApi.post(`/prediction-market/${predictionMarketId}/comments/${commentId}/like`, {}, { headers });
};

export const useLikeComment = (options?: {
  onSuccess?: () => void;
  onError?: () => void;
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, LikeCommentInput>;
}) => {
  const { onSuccess, onError, swrOptions } = options || {};

  const mergedOptions = {
    ...swrOptions,
    onSuccess: () => onSuccess?.(),
    onError: () => onError?.(),
  };

  const { trigger, error, isMutating } = useSWRMutation<void, RomanApiError, string, LikeCommentInput>(
    "like-comment",
    fetcher,
    mergedOptions,
  );

  return {
    likeComment: trigger,
    isMutating,
    error,
  };
};
